import type { ModuleFederationRuntimePlugin } from '@module-federation/enhanced/runtime';

declare global {
  interface Window {
    CUSTOM_REMOTES: Record<string, string>;
  }
}

/**
 * This plugin replaces the remote entry URL for a federated module with a
 * custom remote entry URL from the CUSTOM_REMOTES window object, for all
 * remote applications that have been set up to be served differently.
 */
const customRemotesPlugin: () => ModuleFederationRuntimePlugin = () => ({
  name: 'custom-remotes-plugin',
  beforeRequest(args) {
    if (window.location.hostname !== 'localhost') {
      return args;
    }
    for (const remote of args.options.remotes) {
      if (window.CUSTOM_REMOTES[remote.name]) {
        Object.assign(remote, { entry: window.CUSTOM_REMOTES[remote.name] });

        console.debug(
          'Custom remote entry:',
          remote.name,
          window.CUSTOM_REMOTES[remote.name],
        );
      }
    }
    return args;
  },
  resolveShare(args) {
    const shouldOverrideResolver =
      window.location.hostname === 'localhost' &&
      args.pkgName.startsWith('@libs/');

    if (!shouldOverrideResolver) {
      return args;
    }

    const originalResolver = args.resolver;
    const { shareScopeMap, scope, pkgName, version, GlobalFederation } = args;

    args.resolver = () => {
      const matchingInstances = GlobalFederation.__INSTANCES__.filter(
        instance =>
          instance.name in window.CUSTOM_REMOTES &&
          instance.options.shared[pkgName] !== undefined,
      );

      if (matchingInstances.length > 0) {
        const matchingInstance = matchingInstances[0];
        const current = shareScopeMap[scope][pkgName][version];
        const override = matchingInstance.options.shared[pkgName][0];

        const chosen = current.from === override.from ? current : override;
        return { shared: chosen, useTreesShaking: false };
      }

      return originalResolver();
    };

    return args;
  },
});

export default customRemotesPlugin;
